import React from 'react';
import { CheckIcon } from '../../../components/Icons';
import { Config } from '../../../helpers/config';

import './ValidationRow.css';

type ValidationRowProps = {
  label: string;
  isValid: boolean;
};

export const ValidationRow: React.FC<ValidationRowProps> = ({
  isValid,
  label,
}) => {
  return (
    <div className="validation-row--container">
      <CheckIcon
        width={18}
        height={18}
        color={isValid ? Config.primaryBlue : '#d0d0d0'}
      />
      <p className="validation-row--label">{label}</p>
    </div>
  );
};
